// 辅助函数
function definePropertyIfNotExists(target, source) {
  for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key) &&!Object.prototype.hasOwnProperty.call(target, key)) {
          Object.defineProperty(target, key, {
              enumerable: true,
              get: source[key]
          });
      }
  }
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function markAsModule(obj) {
  if (typeof Symbol!== 'undefined' && Symbol.toStringTag) {
      Object.defineProperty(obj, Symbol.toStringTag, { value: 'Module' });
  }
  Object.defineProperty(obj, '__esModule', { value: true });
}

// handleEncrypt 函数
async function handleEncrypt(hashFunction, url, key = 'ekyc') {
  return new Promise((resolve, reject) => {
      const paramsObj = {};
      const paramListWithoutSign = [];
      const paramsString = decodeURIComponent(url.split('?')[1]);

      if (typeof paramsString === 'undefined') {
          reject('URL中未携带任何参数');
      }
      if (/<[^>]+>/gi.test(paramsString)) {
          reject('URL中含有非法参数！');
      }

      const paramPairs = paramsString.split('&');
      for (let i = 0; i < paramPairs.length; i++) {
          if (paramPairs[i].indexOf('sign') === -1) {
              paramListWithoutSign.push(paramPairs[i]);
          }
      }

      const sortedParams = paramListWithoutSign.sort();
      for (let i = 0; i < sortedParams.length; i++) {
          const equalIndex = sortedParams[i].indexOf('=');
          if (equalIndex!== -1) {
              const key = sortedParams[i].substring(0, equalIndex);
              const value = sortedParams[i].substring(equalIndex + 1);
              paramsObj[key] = unescape(value);
          }
      }

      const paramStrings = [];
      for (const key in paramsObj) {
          paramStrings.push(`${key}=${paramsObj[key]}`);
      }

      const appIdSlice = paramsObj.app_id.slice(1, 8);
      const sortedParamString = paramStrings.sort().join('&');
      const hashResult1 = hashFunction(sortedParamString + appIdSlice).toString();
      const finalResult = hashFunction(hashResult1.slice(0, 6) + key).toString().slice(24, 32);
      resolve(finalResult);
  });
}

// checkMatch 函数
async function checkMatch(hashFunction, url, key = 'ekyc') {
  return new Promise((resolve, reject) => {
      let isMatch;
      const paramsObj = {};
      const paramListWithoutSign = [];
      let signValue = '';
      let debugModeValue = '';
      const paramsString = decodeURIComponent(url.split('?')[1]);

      if (typeof paramsString === 'undefined') {
          reject('URL中未携带任何参数');
      }
      if (/<[^>]+>/gi.test(paramsString)) {
          reject('URL中含有非法参数！');
      }

      const paramPairs = paramsString.split('&');
      for (let i = 0; i < paramPairs.length; i++) {
          if (paramPairs[i].indexOf('sign') === -1) {
              paramListWithoutSign.push(paramPairs[i]);
          }
          if (paramPairs[i].indexOf('debugMode') > -1) {
              debugModeValue = paramPairs[i].split('=')[1];
          }
          if (paramPairs[i].indexOf('sign') > -1) {
              signValue = paramPairs[i].split('=')[1];
          }
      }

      if (!signValue) {
          reject('参数中缺少 sign');
      }

      const sortedParams = paramListWithoutSign.sort();
      for (let i = 0; i < sortedParams.length; i++) {
          const equalIndex = sortedParams[i].indexOf('=');
          if (equalIndex!== -1) {
              const key = sortedParams[i].substring(0, equalIndex);
              const value = sortedParams[i].substring(equalIndex + 1);
              paramsObj[key] = unescape(value);
          }
      }

      const paramStrings = [];
      for (const key in paramsObj) {
          paramStrings.push(`${key}=${paramsObj[key]}`);
      }

      const appIdSlice = paramsObj.app_id.slice(1, 8);
      const sortedParamString = paramStrings.sort().join('&');
      const hashResult1 = hashFunction(sortedParamString + appIdSlice).toString();
      const calculatedSign = hashFunction(hashResult1.slice(0, 6) + key).toString().slice(24, 32);
      isMatch = calculatedSign === signValue;

      if (debugModeValue) {
          paramsObj.debugMode = debugModeValue;
      }
      paramsObj.sign = signValue;
      resolve({ isMatch, urlParams: paramsObj });
  });
}

// 导出模块
const moduleExports = {};
markAsModule(moduleExports);
definePropertyIfNotExists(moduleExports, {
  handleEncrypt: () => handleEncrypt,
  checkMatch: () => checkMatch
});

moduleExports.default = {
  handleEncrypt,
  checkMatch
};

export default moduleExports;



// WEBPACK FOOTER //
// ./src/util/plugin.js